module.exports = __webpack_public_path__ + "static/media/Group 48.d26225bb.svg";